import { render, staticRenderFns } from "./GiftGoal.vue?vue&type=template&id=b6f55588"
import script from "./GiftGoal.vue?vue&type=script&lang=js"
export * from "./GiftGoal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports